import React, { FC } from "react";
import { Typography, Button, Pagination } from "antd";
import { VpdList } from "../vpd-list";
import { MatterModalTemplateSearch, PracticeArea, Template } from "../../data-types";
import { TemplateTitleSearch } from "./client-template-tab";

import styles from "./tabs.css";
import { PracticeAreasCascader } from "../practice-area/practice-area-cascader";

const {
  ["tab-content"]: tabContentClassName,
  ["template-list"]: templateListClassName,
  ["pagination-container"]: paginationContainerClassName,
} = styles as any;

type Props = {
  items: Template[];
  onSelect: (template: Template) => void;
  practiceAreas: PracticeArea[];
  onChangePracticeArea: (practiceAreaId: number) => void;
  loading?: boolean;
  defaultPracticeAreaValue?: number;
  templateSearch: MatterModalTemplateSearch;
  pagination: {
    current: number;
    total: number;
    onChange: (page: number, pageSize: number) => void;
    defaultPageSize?: number;
  };
};

export const PracticeAreaTemplateTab: FC<Props> = ({
  items,
  onSelect,
  onChangePracticeArea,
  loading,
  defaultPracticeAreaValue,
  templateSearch,
  pagination,
}) => {
  return (
    <div className={tabContentClassName}>
      <PracticeAreasCascader
        allowClear={true}
        selectedId={defaultPracticeAreaValue}
        onChange={(val) => {
          return onChangePracticeArea(val);
        }}
      />
      <TemplateTitleSearch
        templateSearch={templateSearch}
        placeholder="Enter part of matter title to search"
      />
      <VpdList
        itemKeyProperty="id"
        itemTextProperty="text"
        items={items}
        bordered={false}
        loading={loading}
        labels={{
          emptyText: "No items found",
        }}
        listStyle="primary"
        renderItem={(item) => {
          return (
            <VpdList.Item
              key={item.id}
              content={<Typography.Text>{item.title}</Typography.Text>}
              contentSuffix={<Button onClick={() => onSelect(item)}>Select</Button>}
            />
          );
        }}
        className={templateListClassName}
      />
      <div className={paginationContainerClassName}>
        <Pagination
          current={pagination.current}
          onChange={pagination.onChange}
          total={pagination.total}
          defaultPageSize={pagination.defaultPageSize}
        />
      </div>
    </div>
  );
};
